import React from 'react';

type Props = {
  onClick: () => void;
};

export const FrontBackdrop: React.FC<Props> = ({ onClick }) => (
  <button
    type="button"
    className="ips-frontfw-overlay__backdrop"
    aria-label="Close"
    onClick={onClick}
  />
);
